<div class="modal-content-wrapper">
  <div class="modal-header">
    <h4 class="modal-title pull-left w-100" [class.text-center]="options.hideCloseButton">
      @if (options.title) {
      {{options.title}}
      }
    </h4>
    @if (!options.hideCloseButton) {
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    }
  </div>
  @if (options.message) {
  <div class="modal-body">
    <p class="text-center mb-0">{{options.message}}</p>
  </div>
  }
  <div class="modal-footer justify-content-center">
    @if (options.no) {
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      {{options.no}}
    </button>
    }

    @if (options.yes) {
    <button type="button" class="btn btn-success" (click)="confirm()">
      {{options.yes}}
    </button>
    }
  </div>
</div>